export default values => {
    if (!Array.isArray(values) || !values.length) {
        return '-';
    }

    return values.map(value => value.name).join(', ');
};
